import React, { useState } from "react";
import styled from "styled-components";
import { injectIntl } from "react-intl";
import dayjs from "dayjs";

const Wrapper = styled.div`
  position: relative;
  align-self: ${(p) => (p.fromSelf ? "flex-end" : "flex-start")};
  margin-bottom: ${(p) => (p.fromSelf ? 16 : 32)}px;
  padding: 10px;
  width: fit-content;
  min-width: 40px;
  max-width: 85%;
  border-radius: 10px;
  background-color: ${(p) => (p.fromSelf ? p.theme.colors.success : "#eee")};
  color: ${(p) => (p.fromSelf ? p.theme.colors.on.success : "#000")};
  font-size: 13px;

  :last-of-type {
    margin-bottom: 12px;
  }
`;

export const NoteSender = styled.div`
  position: absolute;
  top: -18px;
  left: 0;
  color: #999;
  text-align: right;
  white-space: nowrap;
  font-size: 12px;
`;

export const NoteTime = styled.div`
  position: absolute;
  top: 100%;
  right: ${(p) => (p.fromSelf ? 0 : "auto")};
  left: ${(p) => (p.fromSelf ? "auto" : 0)};
  color: #999;
  text-align: right;
  white-space: nowrap;
  font-size: 12px;
`;

const Note = (props) => {
  const { intl, note, origin, createdByRole, created } = props;
  const [hovered, setHovered] = useState(false);
  const fromSelf = origin === "portal" ? true : false;

  return (
    <Wrapper
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      fromSelf={fromSelf}
    >
      {origin !== "portal" && createdByRole && (
        <NoteSender>
          {intl.formatMessage({
            id: `note.${createdByRole}`,
          })}
        </NoteSender>
      )}
      {note.split("\n").map((n, i) => (
        <React.Fragment key={`line-${i}`}>
          {n}
          <br />
        </React.Fragment>
      ))}
      {hovered && created && (
        <NoteTime fromSelf={fromSelf}>
          {dayjs(created).locale(intl.locale).fromNow()}
        </NoteTime>
      )}
    </Wrapper>
  );
};

export default injectIntl(Note);
